import { Timestamp } from 'firebase/firestore'

/** مدينة تخزين مطاعم LMenus — منفصلة عن مدن تطبيق «مدينتك بين ايديك» */
export const LMENUS_CITY = 'virtual'
export const LMENUS_PRODUCT_NAME = 'Restora'

export const LMENUS_PACKAGES_COL = 'lmenus_packages'
export const LMENUS_SETTINGS_COL = 'lmenus_settings'
export const LMENUS_SETTINGS_DOC_ID = 'site'
export const LMENUS_UPGRADES_COL = 'lmenus_upgrade_requests'

export const DEFAULT_FREE_PACKAGE = {
  name_ar: 'تجربة',
  price_egp: 0,
  duration_days: 14,
  max_sections: 2,
  max_items: 15,
  max_tables: 5,
  ai_upload: false,
  hall_orders: true,
  pos_enabled: false,
  max_pos_staff: 0,
  is_free: true,
  active: true,
  sorter: 0,
  features: [
    'موقع كامل برابط خاص بمطعمك',
    'الطلبات توصل على واتساب المطعم',
    'طلب من الصالة باختيار الترابيزة',
    'QR جاهز للطباعة على الترابيزات'
  ]
}

/** باقات مقترحة تُزرع لو المجموعة فاضية أو ناقصة */
export const DEFAULT_SEED_PACKAGES = [
  DEFAULT_FREE_PACKAGE,
  {
    name_ar: 'أساسي',
    price_egp: 199,
    duration_days: 30,
    max_sections: 8,
    max_items: 80,
    max_tables: 20,
    ai_upload: false,
    hall_orders: true,
    pos_enabled: true,
    max_pos_staff: 3,
    is_free: false,
    active: true,
    sorter: 10,
    features: ['موقع كامل بمنيو وطلبات', 'طلب صالة حتى 20 ترابيزة', 'مناسب للكافيهات الصغيرة']
  },
  {
    name_ar: 'احترافي',
    price_egp: 349,
    duration_days: 90,
    max_sections: 20,
    max_items: 250,
    max_tables: 60,
    ai_upload: true,
    hall_orders: true,
    pos_enabled: true,
    max_pos_staff: 8,
    is_free: false,
    active: true,
    sorter: 20,
    features: ['3 شهور', 'رفع المنيو بالذكاء الاصطناعي', 'الأكثر طلباً']
  },
  {
    name_ar: 'سنوي',
    price_egp: 1199,
    duration_days: 365,
    max_sections: 40,
    max_items: 1000,
    max_tables: 200,
    ai_upload: true,
    hall_orders: true,
    pos_enabled: true,
    max_pos_staff: 20,
    is_free: false,
    active: true,
    sorter: 30,
    features: ['سنة كاملة', 'حدود واسعة للأقسام والأصناف', 'ترابيزات بلا قلق']
  }
]

export const DEFAULT_LANDING = {
  enabled: true,
  brand: LMENUS_PRODUCT_NAME,
  hero_title: 'موقع كامل لمطعمك أو كافيهك — مش مجرد منيو QR',
  hero_subtitle:
    'صفحة مطعم احترافية بمنيو وصور وطلبات وطلب من الصالة باختيار الترابيزة — والطلب يوصلك على واتسابك مباشرة. يفتح من الويب ومن التطبيق، وتتحكم فيه بنفسك من لوحة تحكم بالعربي.',
  hero_image: '',
  cta_label: 'ابدأ مجاناً',
  secondary_cta_label: 'شوف موقع جاهز',

  demo_enabled: true,
  demo_title: 'كده بالظبط هيبقى شكل موقعك',
  demo_desc:
    'نفس الموقع يفتح من المتصفح على الكمبيوتر والموبايل، وكمان جوه التطبيق. اتفرج على نموذج شغال فعلاً.',
  demo_url: '',
  demo_cta_label: 'جرّب الموقع الآن',
  demo_web_image: '',
  demo_web_caption: 'من الويب',
  demo_mobile_image: '',
  demo_mobile_caption: 'من التطبيق',

  features_title: 'كل اللي مطعمك محتاجه في مكان واحد',
  features_subtitle: 'مش بس منيو — سيستم كامل لإدارة المطعم وعرضه للعملاء.',
  features: [
    {
      title: 'موقع مطعم كامل',
      desc: 'صفحة بهوية مطعمك: لوجو، صور، ألوان، مواعيد عمل، أرقام تواصل وسوشيال.',
      image: ''
    },
    {
      title: 'منيو رقمي بصور',
      desc: 'أقسام وأصناف بأسعار وصور وأحجام وإضافات — تعديل لحظي بدون مبرمج.',
      image: ''
    },
    {
      title: 'طلبات أونلاين',
      desc: 'العميل يطلب من الموقع والطلب يوصلك فوراً على لوحة التحكم — وكمان على واتساب مطعمك مباشرة.',
      image: ''
    },
    {
      title: 'الطلبات على واتساب',
      desc: 'كل طلب جديد يتبعت تلقائيًا على رقم واتساب المطعم عشان الرد يكون أسرع.',
      image: ''
    },
    {
      title: 'طلب من الصالة',
      desc: 'العميل يختار رقم الترابيزة ويطلب من موبايله وهو قاعد عندك.',
      image: ''
    },
    {
      title: 'QR للترابيزات',
      desc: 'كود جاهز للطباعة يفتح موقع مطعمك على طول بدون تحميل أي تطبيق.',
      image: ''
    },
    {
      title: 'لوحة تحكم بالعربي',
      desc: 'تحكم في الأقسام والأصناف والعروض والطلبات والعملاء من مكان واحد.',
      image: ''
    }
  ],

  hall_enabled: true,
  hall_title: 'طلب من الصالة باختيار الترابيزة',
  hall_desc:
    'سجّل أسماء ترابيزاتك مرة واحدة، والعميل يختار ترابيزته من الموقع ويبعت الطلب — يوصلك مكتوب عليه رقم الترابيزة بدون لغبطة ولا نداء على الويتر.',
  hall_image: '',
  hall_points: [
    'أسماء الترابيزات تتضبط من لوحة التحكم',
    'العميل يختار الترابيزة قبل تأكيد الطلب',
    'الطلب يوصل للكاشير مكتوب عليه الترابيزة',
    'متاح في كل الباقات — حتى التجربة المجانية'
  ],

  packages_title: 'الباقات',
  packages_subtitle: 'ابدأ مجاناً، واترقّى وقت ما تحب — الترقية بتتفعّل يدوياً بعد التواصل.',

  footer_title: 'جاهز نطلّع موقع مطعمك؟',
  footer_desc: 'التسجيل مجاني وبيأخذ دقيقة — ومعاك فترة تجربة كاملة بكل المميزات.',
  footer_note: '',

  /** تذييل بروفايل المطاعم — رابط الشركة */
  powered_by_label: 'بروكود',
  powered_by_url: 'https://procode-solutions.com/',

  /** أيقونات شريط التواصل (صور شفافة اختيارية) — فارغة = الافتراضي المدمج */
  action_icons: {
    phone: '',
    whatsapp: '',
    location: '',
    menu: '',
    facebook: '',
    instagram: '',
    share: ''
  }
}

export function normalizeLandingFeature(raw) {
  if (raw == null) return null
  if (typeof raw === 'string') {
    const title = raw.trim()
    return title ? { title, desc: '', image: '' } : null
  }
  if (typeof raw !== 'object') return null
  const title = String(raw.title || '').trim()
  const desc = String(raw.desc || '').trim()
  if (!title && !desc) return null
  return { title, desc, image: String(raw.image || '').trim() }
}

/** توحيد إعدادات صفحة الهبوط مع القيم الافتراضية */
export function normalizeLandingSettings(raw = {}) {
  const merged = { ...DEFAULT_LANDING, ...raw }
  const features = Array.isArray(raw.features)
    ? raw.features.map(normalizeLandingFeature).filter(Boolean)
    : DEFAULT_LANDING.features
  const hallPoints = Array.isArray(raw.hall_points)
    ? raw.hall_points.map((p) => String(p || '').trim()).filter(Boolean)
    : DEFAULT_LANDING.hall_points
  const actionIcons = {
    ...DEFAULT_LANDING.action_icons,
    ...(raw.action_icons && typeof raw.action_icons === 'object' ? raw.action_icons : {})
  }
  for (const key of Object.keys(DEFAULT_LANDING.action_icons)) {
    actionIcons[key] = String(actionIcons[key] || '').trim()
  }
  return {
    ...merged,
    features,
    hall_points: hallPoints,
    powered_by_label: String(merged.powered_by_label || DEFAULT_LANDING.powered_by_label).trim(),
    powered_by_url: String(merged.powered_by_url || DEFAULT_LANDING.powered_by_url).trim(),
    action_icons: actionIcons
  }
}

export function isLMenusRestaurant(entity) {
  return entity?.lmenus === true || entity?.lmenus === 'true'
}

export function normalizeLmenusPackage(raw = {}) {
  return {
    id: raw.id || '',
    name_ar: String(raw.name_ar || '').trim() || 'باقة',
    price_egp: Math.max(0, Number(raw.price_egp) || 0),
    duration_days: Math.max(0, Math.floor(Number(raw.duration_days) || 0)),
    max_sections: Math.max(1, Math.floor(Number(raw.max_sections) || 1)),
    max_items: Math.max(1, Math.floor(Number(raw.max_items) || 1)),
    max_tables: Math.max(0, Math.floor(Number(raw.max_tables) || 0)),
    ai_upload: raw.ai_upload === true,
    // الباقات القديمة ما فيهاش الحقل — طلب الصالة متاح افتراضياً في كل الباقات
    hall_orders: raw.hall_orders == null ? true : raw.hall_orders === true,
    // نظام الكاشير (POS): مقفول افتراضياً في الباقات القديمة
    pos_enabled: raw.pos_enabled === true,
    max_pos_staff: Math.max(0, Math.floor(Number(raw.max_pos_staff) || 0)),
    is_free: raw.is_free === true || Number(raw.price_egp) === 0,
    active: raw.active !== false,
    sorter: Number(raw.sorter) || 0,
    features: Array.isArray(raw.features)
      ? raw.features.map((f) => String(f || '').trim()).filter(Boolean)
      : []
  }
}

export function packageExpiresAtFromNow(durationDays, fromDate = new Date()) {
  const days = Math.max(0, Math.floor(Number(durationDays) || 0))
  if (days <= 0) return null
  const d = new Date(fromDate)
  d.setDate(d.getDate() + days)
  d.setHours(12, 0, 0, 0)
  return Timestamp.fromDate(d)
}

/** حقول الباقة اللي تتخزن على وثيقة المطعم */
export function buildRestaurantLmenusFields(pkg, { fromDate = new Date() } = {}) {
  const p = normalizeLmenusPackage(pkg)
  const expires = packageExpiresAtFromNow(p.duration_days, fromDate)
  return {
    lmenus: true,
    lmenusPackageId: String(p.id || '').trim(),
    lmenusPackageName: p.name_ar,
    lmenusMaxSections: p.max_sections,
    lmenusMaxItems: p.max_items,
    lmenusMaxTables: p.max_tables,
    lmenusAiUpload: !!p.ai_upload,
    lmenusHallOrders: !!p.hall_orders,
    hallOrders: !!p.hall_orders,
    posEnabled: !!p.pos_enabled,
    posMaxStaff: p.pos_enabled ? p.max_pos_staff : 0,
    qrEnabled: true,
    qrExpiresAt: expires,
    where: LMENUS_CITY
  }
}

export function readRestaurantLmenusLimits(restaurant) {
  if (!isLMenusRestaurant(restaurant)) {
    return {
      enabled: false,
      maxSections: Infinity,
      maxItems: Infinity,
      maxTables: Infinity,
      aiUpload: true,
      hallOrders: true,
      posEnabled: restaurant?.posEnabled === true,
      posMaxStaff: Math.max(0, Number(restaurant?.posMaxStaff) || 0)
    }
  }
  return {
    enabled: true,
    maxSections: Math.max(1, Number(restaurant.lmenusMaxSections) || 1),
    maxItems: Math.max(1, Number(restaurant.lmenusMaxItems) || 1),
    maxTables: Math.max(0, Number(restaurant.lmenusMaxTables) || 0),
    aiUpload: restaurant.lmenusAiUpload === true,
    hallOrders: restaurant.lmenusHallOrders !== false,
    posEnabled: restaurant.posEnabled === true,
    posMaxStaff: Math.max(0, Number(restaurant.posMaxStaff) || 0),
    packageName: String(restaurant.lmenusPackageName || '').trim() || '—',
    packageId: String(restaurant.lmenusPackageId || '').trim()
  }
}

export function formatDurationLabel(days) {
  const n = Math.floor(Number(days) || 0)
  if (n <= 0) return 'بدون مدة محددة'
  if (n === 1) return 'يوم واحد'
  if (n === 7) return 'أسبوع'
  if (n === 14) return '14 يوم'
  if (n === 30) return 'شهر'
  if (n === 90) return '3 شهور'
  if (n === 180) return '6 شهور'
  if (n === 365) return 'سنة'
  return `${n} يوم`
}

export function formatPriceLabel(price) {
  const n = Number(price) || 0
  if (n <= 0) return 'مجاناً'
  return `${n} ج.م`
}

/** ترتيب الباقات للعرض */
export function sortPackages(list) {
  return [...(list || [])].sort((a, b) => {
    if (!!a.is_free !== !!b.is_free) return a.is_free ? -1 : 1
    if (a.sorter !== b.sorter) return a.sorter - b.sorter
    return a.price_egp - b.price_egp
  })
}
